'use client';

import {
  Typography,
  type TypographyProps,
} from '@jouzen/ecom-components/v3/Typography';

const DEFAULT_PROPS: Partial<TypographyProps> = {
  Element: 'h3',
  variant: 'h5',
};

export const SectionHeading = ({
  children,
  ...rest
}: Partial<TypographyProps>) => {
  const props = { ...DEFAULT_PROPS, ...rest };
  return <Typography {...props}>{children}</Typography>;
};

export default SectionHeading;
